import { useActiveRole } from 'App/context/ActiveRoleContext';

export const useUserActiveRole = () => {
  return useActiveRole().activeRole;
};
